<script>
import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../stores";
import { onMount } from 'svelte'
import { createEventDispatcher } from "svelte";
import CircularIndicator from "./CircularIndicator.svelte";
import FloattingWindow from './FloattingWindow.svelte';
import DatePicker from './Calendar/DatePicker.svelte'
import { tweened } from 'svelte/motion';
import { cubicOut } from 'svelte/easing';
import GLOBALS from "../globals/GLOBALS";
import * as Fx from "../globals/Fx";
import ButtonCircular from "./ButtonCircular.svelte";
import OptionAvance from "./liquidaciones/OptionAvance.svelte";
import OptionConsumos from "./liquidaciones/OptionConsumos.svelte";
import OptionImporteLiquidado from "./liquidaciones/OptionImporteLiquidado.svelte";
import OptionRecaudo from "./liquidaciones/OptionRecaudo.svelte";
import ScreenConsumos from "./liquidaciones/ScreenConsumos.svelte";
import ScreenListaConsumos from "./liquidaciones/ScreenListaConsumos.svelte";
import ScreenPdf from "./liquidaciones/ScreenPDF.svelte";
import ScreenBaseGravable from "./liquidaciones/ScreenBaseGravable.svelte";
import ScreenSimularLiquidaciones from "./liquidaciones/ScreenSimularLiquidaciones.svelte";
import ScreenListaRecaudos from "./liquidaciones/ScreenListaRecaudos.svelte";


let w
let h
let addPeriodo = false
let handleBaseGravable = false
let handleConsumos = false
let handleListaConsumos = false
let handleListaPDF = false
let handleSimularLiquidacion = false
let handleListaRecaudo = false
let periodo
let YEARS = []
let MONTHS = []
let CANTSUS = []
let LIQUIDADOS = null
let YEAR = 0
let MONTH = ""
let report

const opacity = tweened(0, {
    duration: 2000,
    easing: cubicOut
});

onMount(async () => {
   await _LIQ_QUERY("LISTYEARS",{});
   YEAR =  YEARS[0].YEAR
   await _LIQ_QUERY("LISTMONTHS",{year:YEAR});
});

const _addPeriodo = () => {
    addPeriodo = true
    opacity.set(1)
}

let currentDate = new Date();

const onDateChange = d => {
    currentDate = d.detail;
    var arr = currentDate.toString().split(" ")
    const month = GLOBALS.MNUM[arr[1]]
    const year = arr[3]
    periodo = `${year}${month}`
};

$: if (YEAR >0 && MONTH !== "" ) {
        _LIQ_QUERY("LIQUIDADOS", {periodo : YEAR.toString()+MONTH})
        LIQUIDADOS = null
        _LIQ_QUERY("LIQUIDADOS", {periodo :  YEAR.toString()+MONTH} )
   }

$: _LIQ_QUERY("LISTMONTHS",{year :YEAR})

const _LIQ_QUERY = async (QUERY, data) => {
    const URL = GLOBALS.URL;
    const bearer = "Bearer " + $TOKEN_SESSION;
    await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: bearer,
            "Content-type": "application/json;charset=UTF-8",
        },
    })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then((json) => {
            if (json.result === "success") {
                switch(QUERY){
                    case "LISTYEARS" :
                        YEARS = json.rows
                    break;
                    case "LISTMONTHS" :
                        MONTHS = json.rows
                        MONTH = GLOBALS.MNUMSP[MONTHS[0].MONTH]
                    break;
                    case "CANTSUS" :
                        CANTSUS = json.rows
                    break;
                    case "LIQUIDADOS" :
                        LIQUIDADOS = json.rows[0]
                    break;
                }
            }else{
                TOAST_MESSAGE.set(json)
                if (json.status === 403) TOKEN_SESSION.set(null)
            }
            
        }) //print data to console
        .catch((err) => -console.log("Request Failed", err)); // Catch errors
};

const _crearNuevoPeriodo = async () => {
    if (!periodo || periodo === 0 || periodo.toString().length < 6) {
        TOAST_MESSAGE.set({result: "error",message: `Error. El valor del periodo ${periodo} es incorrecto!`})
        return
    }
    await _LIQ_QUERY("CANTSUS", {})
    const cantidad = CANTSUS[0].CANTSUS
    const data = {lenc_periodo : periodo};
    const URL = GLOBALS.URL;
    const bearer = "Bearer " + $TOKEN_SESSION;
    await fetch(`${URL}/API/liquidaciones/LENC_CREATE/0/`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: bearer,
            "Content-type": "application/json;charset=UTF-8",
        },
    })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then(async (json) => {
            if (json.result === "success") {
                YEARS = []
                addPeriodo = false
                opacity.set(0)
                await _LIQ_QUERY("LISTYEARS",{});
                await _LIQ_QUERY("LISTMONTHS",{year:2021});
                TOAST_MESSAGE.set(json)
            }else{
                TOAST_MESSAGE.set(json)
            }
        }) //print data to console
        .catch((err) => console.log("Request Failed", err)); // Catch errors
}

const _baseGravable = () => {
    handleBaseGravable = true
    opacity.set(1)
}

const _guardarBaseGravable = () => {
    let data = []
    Object.keys(inputBaseGravable).forEach((key,i) =>{
        if (inputBaseGravable[key]) {
            data.push({ 
                    bas_periodo : key.split("-")[0], 
                    bas_estrato : key.split("-")[1], 
                    bas_base_gravable: inputBaseGravable[key].value 
                  })
            }
    })
    _LIQ_QUERY("GUARDARBASEGRAVABLE",{data})
}

const _btnCloseBaseGravable = () => {
    inputBaseGravable = {}
    handleBaseGravable = false; opacity.set(1)
}

const _handleOptionClick = (e) => {
    switch(e.detail.opcion){
        case "CSMO-UPLOAD":
            handleConsumos = true
            opacity.set(1)
        break;
        case "CSMO-LISTADO":
            handleListaConsumos = true
            opacity.set(1)
        break;
        case "AVANCE-LISTADO":
            handleListaPDF = true
            opacity.set(1)
        break;
        case "AVANCE-EXEC":
            handleSimularLiquidacion = true
            opacity.set(1)
        break;
        case "RECAUDO-LISTADO":
            handleListaRecaudo = true
            opacity.set(1)
        break;
    }
}

</script>

<div class="main-liquidaciones" >
    <div class="title">Liquidaciones</div>
    {#if addPeriodo }
        <div style="opacity: {$opacity};">
            <h4 class="" style="text-align: center; margin-top: 20px;}"> Crear un nuevo Periodo de Liquidación</h4>
            <div class="set-liquidaciones justify-content-center d-flex align-items-center  ">
                <div class="calendar">
                    <DatePicker
                        on:datechange={onDateChange}
                        selected={currentDate}
                        allwaysShow={true}
                        boxStyle={"background-color:#2c3e50;color:#fff"}
                        inputStyle={"background-color: #efefef;border: none;padding: 10px;"}
                    />
                </div>
                <div class="formulario d-flex justify-content-center flex-column ">
                    <div class="form-floating mb-3">
                        <input type="number" bind:value={periodo} class="form-control" id="floatingInput" placeholder="periodo"  pattern="[0-9]+">
                        <label for="floatingInput">Periodo</label>
                    </div>
                    <!-- <div class="form-floating mb-3">
                        <input type="number" bind:value={tasaGravable} class="form-control" id="floatingInput" placeholder="periodo"  pattern="[0-9]+,">
                        <label for="floatingInput">Tasa Gravable</label>
                    </div> -->
                    <div class="btn btn-primary" on:click={() => _crearNuevoPeriodo()}>Guardar</div>
                    <div class="btn btn-danger"  on:click={() => {addPeriodo = false; opacity.set(0)}}>Cerrar</div>
                </div>
            </div>
        </div>
    {:else if handleBaseGravable}
            <ScreenBaseGravable
                opacity={$opacity}
                on:close={() => {handleBaseGravable = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else if handleConsumos}
            <ScreenConsumos 
                opacity={$opacity} 
                on:close={() => {handleConsumos = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else if handleListaConsumos}
            <ScreenListaConsumos 
                opacity={$opacity} 
                on:close={() => {handleListaConsumos = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else if handleListaRecaudo}
            <ScreenListaRecaudos 
                opacity={$opacity} 
                on:close={() => {handleListaRecaudo = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else if handleListaPDF}
            <ScreenPdf 
                opacity={$opacity} 
                on:close={() => {handleListaPDF = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else if handleSimularLiquidacion}
            <ScreenSimularLiquidaciones 
                opacity={$opacity} 
                on:close={() => {handleSimularLiquidacion = false; opacity.set(0)}}
                periodo={YEAR.toString()+MONTH}
            />
    {:else}
        <div class="container-fluid  container-opciones">
            <div class="periodo-container d-flex flex-row">
                <select name="" id="" class="year" bind:value={YEAR}>
                    {#each YEARS as item}
                         <option value={item.YEAR}>{item.YEAR}</option>
                    {/each}
                </select>
                <select class="mes" name="" id="" bind:value={MONTH}>
                    {#each MONTHS as item}
                         <option value={GLOBALS.MNUMSP[item.MONTH]}>{item.MONTH}</option>
                    {/each}
                </select>
                <div 
                    class="add-periodo d-flex justify-content-center align-items-center"
                    on:click={() => _addPeriodo()}
                    title={"Adicionar Periodo"}
                >
                    <ion-icon name="add-outline"></ion-icon>
                </div>
                <div 
                    class="edit-periodo d-flex justify-content-center align-items-center"
                    on:click={() => _baseGravable()}
                    title={"Base Gravable"}
                >
                   <span>%</span>
                </div>
            </div>
            
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-start">
                        <OptionConsumos {LIQUIDADOS} on:click={_handleOptionClick}/>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-start">
                        <OptionImporteLiquidado {LIQUIDADOS} on:click={_handleOptionClick}/>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-start">
                        <OptionRecaudo {LIQUIDADOS} on:click={_handleOptionClick}/>
                    </div>
                    <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-start">
                        <OptionAvance {LIQUIDADOS}  on:click={_handleOptionClick}/>
                    </div>
                </div>
            </div>  
        </div>
    {/if}
    <!-- <button on:click={() => test()}>TEST</button>
    <div id="reporte" style="display:none" bind:this={report}>TESTEST</div> -->
</div>



<style>
    .main-liquidaciones {
        /* display: flex; */
        flex-direction: column;
        padding-top: 0;
        height: 100vh;
        padding-bottom: 52px;
    }
    .title {
        font-size: 3em;
        font-weight: bold;
        padding-right: 20px;
        text-align: right;
        border-bottom: 6px solid;
        color: #2c3e501f;
        line-height: 1;
        background-color: #fff;
    }

    .container-opciones {
        padding-top: 30px;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        height: 100%;
        overflow-y: auto;

    }

    .periodo-container {
        margin-bottom: 2em;
        font-size: 2.5em;
        position: relative;
    }

    .periodo-container > select.year {
        position: absolute;
        font-size: 0.8em;
        border: none;
        left: -94px;
        background-color: #efefef;
        border-radius: 10px;
        top: 10px;
    }

    .periodo-container > select.mes {
        border: none;
        border-bottom: 1px solid #34495e;
        padding: 0;
        font-size: 1.5em;
        color: #34495e
    }

    .add-periodo {
        font-size: 0.8em;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        background-color: #2ecc71;
        color: #fff;
        cursor: pointer;
        transition: transform 250ms;
    }

    .add-periodo:hover {
        transform:scale(1.2)
    }

    .edit-periodo {
        font-size: 0.5em;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        background-color: #f39c12;
        color: #fff;
        cursor: pointer;
        margin-left: 3px;
        transition: transform 250ms;
    }

    .edit-periodo:hover {
        transform:scale(1.2)
    }

    .set-liquidaciones  {
        min-height: 300px;
        background-color: #ffff;
        border: none;
        margin-top: 30px;
    }

    .formulario {
        margin-left : 20px;
    }

    .formulario > .btn {
        margin-top: 5px;
    }

    .form-control {
        color: #d35400;
    }

    /* #reporte {
        width: 100%;
        height: 269mm;
        position: relative;
    } */

</style>
